import React from "react";
import { HorizontalStack, VerticalStack, Text } from "@shopify/polaris";
import { ClockMajor } from "@shopify/polaris-icons";

export const SettingUpYourReloAccount = () => (
  <div
    style={{
      borderRadius: "0.5rem",
      padding: "1.5rem",
      border: "1px solid rgba(180, 229, 245, 1)",
      background: "linear-gradient(to top, rgba(240, 240, 255, 1) 0%, rgba(215, 245, 255, 1) 100%)",
    }}
  >
    <VerticalStack gap="6">
      <HorizontalStack gap="4" align="start" blockAlign="center">
        <div
          style={{
            background: "rgba(207, 242, 255, 1)",
            borderRadius: "100%",
            minWidth: "48px",
            minHeight: "48px",
          }}
        >
          <ClockMajor
            width="24px"
            style={{ display: "block", fill: "rgba(37, 117, 255, 1)", margin: "12px auto" }}
          />
        </div>
        <Text variant="headingLg" fontWeight="semibold" as="p">
          Setting up your Relo account
        </Text>
      </HorizontalStack>

      <Text variant="bodyLg" as="p">
        Great! Our onboarding team has been notified and will reach out shortly to set up your account and
        configure the AI-powered flows in Klaviyo.
        <br />
        <br />
        <Text as="span" fontWeight="semibold">
          Keep an eye on your inbox for next steps from our team!
        </Text>
      </Text>
    </VerticalStack>
  </div>
);
